import { LocationUtilities, SiteUtilities } from '../utils';

var mtgapSubscribeForm = function (classname, form) {
  const email = $(form).find('input[name^="email"]').val();
  var modalId = '#' + $(form).find('.modal-id').val();
  $(form).find('.button').addClass('button--loading').attr('disabled', 'disabled');
  const geoLocation = LocationUtilities.getGeoLocation();
  // Freshmarketer Data
  const fmListId = $(form).find('.fm-list-id').val();
  if (fmListId) {
    const freshmarketerData = {
      freshmarketerObject: {
        email: email,
        country: geoLocation ? geoLocation.countryName : '',
        contactable: true,
        custom_field: {
          cf_freshmarketer_list: fmListId
        },
        overrides: {
          product: 'fchat'
        }
      }
    };
    SiteUtilities.freshmarketerPost(freshmarketerData, true, form);
  }
  setTimeout(function () {
    $(modalId).modal('show');
    $(form).find('.button').removeClass('button--loading').removeAttr('disabled');
    $(form).find('input[name^="email"]').val('');
  }, 500);
};

export default {
  mtgapSubscribeForm
};
